/* eslint-disable no-console */
/* eslint-disable no-useless-return */

import { LogLevel } from '@azure/msal-browser';
import getHostDomain, { STAGING_DOMAIN } from 'helpers/getHostDomain';
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

const hostDomain = getHostDomain();
const clientId =
  hostDomain === STAGING_DOMAIN
    ? '097def9e-d030-409b-bfaf-c72e16f63310'
    : '474ea754-ede0-44cf-b224-d5f2d914a3c8';

export const msalConfig = {
  auth: {
    clientId,
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: `https://login.${encodeURIComponent(
      hostDomain,
    )}.com/microsoft/confirm-subscription`,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read', 'profile', 'email', 'openid'],
};
